import { FunctionResult } from "../classes/common/function-result.class.mjs";
// #region Functions (1)
/**
 * Helper function to create a Function Result
 * @param {FUNCTION_RESULT_STATUS} status
 * @param {T | undefined} obj
 * @param {FunctionResultOptions} options
 * @param {number} totalRows
 * @return {FunctionResult<T>}
 */
export function createFunctionResult(status, obj, options, totalRows) {
  try {
    let myLength = 1;
    if (obj !== undefined) {
      if (Array.isArray(obj)) {
        myLength = obj.length;
      }
    } else {
      myLength = 0;
    }
    if (totalRows !== undefined) {
      myLength = totalRows;
    }
    return new FunctionResult(status, obj, myLength, options);
  } catch (error) {
    console.error(error);
    throw new Error("Unable to create new Function Result", {
      cause: error
    });
  }
}
// #endregion Functions (1)